/** GA4 Measurement ID (also used by deferred gtag.js URL). */
export const GA4_MEASUREMENT_ID = 'G-R368FHHM10';

let ga4BootstrapScheduled = false;

/**
 * Loads gtag.js after the main thread is idle so it does not compete with first paint / app JS.
 * Events and config calls queue in dataLayer until the library loads (official GA pattern).
 */
export function scheduleGa4ScriptLoad() {
  if (typeof window === 'undefined' || ga4BootstrapScheduled) return;
  ga4BootstrapScheduled = true;

  const inject = () => {
    if (window.__playfynd_ga4_script_injected) return;
    window.__playfynd_ga4_script_injected = true;

    const s = document.createElement('script');
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_MEASUREMENT_ID}`;
    s.onload = () => {
      if (window.__playfynd_ga4_configured) return;
      window.__playfynd_ga4_configured = true;
      window.gtag('js', new Date());
      window.gtag('config', GA4_MEASUREMENT_ID, { send_page_view: true });
    };
    document.head.appendChild(s);
  };

  const run = () => inject();

  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(run, { timeout: 4500 });
  } else {
    window.addEventListener('load', () => setTimeout(run, 0), { once: true });
  }
}

if (typeof window !== 'undefined') {
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== 'function') {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }
}

function gaEvent(eventName, params) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('event', eventName, params);
}

export function trackLogin(method) {
  gaEvent('login', { method: String(method || 'unknown') });
}

export function trackSignUp(method) {
  gaEvent('sign_up', { method: String(method || 'unknown') });
}

export function trackCreateActivity(category) {
  gaEvent('create_activity', { activity_category: String(category || '') });
}

export function trackActivityJoin({ activityId, category }) {
  gaEvent('activity_join', {
    activity_id: String(activityId || ''),
    activity_category: String(category || ''),
  });
}

export function trackActivityLeave({ activityId, category }) {
  gaEvent('activity_leave', {
    activity_id: String(activityId || ''),
    activity_category: String(category || ''),
  });
}

export function trackActivityDelete({ activityId, category }) {
  gaEvent('activity_delete', {
    activity_id: String(activityId || ''),
    activity_category: String(category || ''),
  });
}

export function trackWishlistAdd({ activityId, category }) {
  gaEvent('add_to_wishlist', {
    items: [{ item_id: String(activityId || ''), item_category: String(category || '') }],
  });
}

export function trackWishlistRemove({ activityId, category }) {
  gaEvent('remove_from_wishlist', {
    items: [{ item_id: String(activityId || ''), item_category: String(category || '') }],
  });
}
